module.exports = __webpack_public_path__ + "static/exam1-8d8bf22749284ec0a81d958869bab3a1.png";